export default class Shuffle {
  constructor(scene, config) {
    this.scene = scene;
    this.lastRootPiece = { x: 0, y: 0 };
    this.lag = { x: 0, y: 1 };
    this.rootEndHelper = null;
  }

  startGrow(startX, startY) {
    // add a root sprite at x, y
    this._drawRootPiece(startX, startY);
    this.rootEndHelper = this.scene.physics.add.sprite(startX, startY - this.lag.y + 1, 'root', 1);
  }

  beforeDraw(config) {
    this._rootEnd = config.rootEnd;
    this.rootEndHelper.x = this._rootEnd.x;
    this.rootEndHelper.y = this._rootEnd.y - this.lag.y;
    let controller = config.controller;
  }

  willDraw() {
    return this._rootEnd.y - this.lastRootPiece.y > this.lag.y + 1.5;
  }

  draw() {
    this._drawRootPiece(this._rootEnd.x - this.lag.x, this._rootEnd.y - this.lag.y);
  }

  _drawRootPiece(x, y) {
    this.lastRootPiece = { x: x, y: y };
    this.scene.physics.add.sprite(x, y, 'root', 1);
  }
}